/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Window = ({ color = 'forest', height = 14, width = 14 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${height} ${width}`}
      sx={{ fill: color }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.2 2.8H12.6V1.4H4.2V2.8ZM1.4 12.6H12.6V4.2H1.4V12.6ZM1.4 2.8H2.8V1.4H1.4V2.8ZM0 14H14V0H0V14Z"
        fill={color}
      />
    </svg>
  )
}

Window.propTypes = {
  color: string,
  height: number,
  width: number,
}

export default Window
